interface GlyphProps {
  readonly class?: string | undefined
}

/** Four signal bars, all full. */
export function SignalGlyph({ class: className }: GlyphProps) {
  return (
    <svg class={className} viewBox="0 0 18 12" fill="currentColor" aria-hidden="true">
      <rect x="0" y="8" width="3" height="4" rx="1" />
      <rect x="5" y="5.5" width="3" height="6.5" rx="1" />
      <rect x="10" y="3" width="3" height="9" rx="1" />
      <rect x="15" y="0" width="3" height="12" rx="1" />
    </svg>
  )
}

/** Wi-Fi: three arcs over a dot. */
export function WifiGlyph({ class: className }: GlyphProps) {
  return (
    <svg
      class={className}
      viewBox="0 0 16 12"
      fill="none"
      stroke="currentColor"
      stroke-width="1.9"
      stroke-linecap="round"
      aria-hidden="true"
    >
      <path d="M1.3 4.3a9.5 9.5 0 0 1 13.4 0" />
      <path d="M3.55 6.55a6.3 6.3 0 0 1 8.9 0" />
      <path d="M5.8 8.8a3.1 3.1 0 0 1 4.4 0" />
      <circle cx="8" cy="11" r="1" fill="currentColor" stroke="none" />
    </svg>
  )
}

/** A battery about four fifths full. */
export function BatteryGlyph({ class: className }: GlyphProps) {
  return (
    <svg class={className} viewBox="0 0 27 13" fill="currentColor" aria-hidden="true">
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="12"
        rx="3.6"
        fill="none"
        stroke="currentColor"
        stroke-opacity="0.4"
      />
      <rect x="2" y="2" width="16.5" height="9" rx="2.2" />
      <rect x="24.6" y="4.5" width="1.9" height="4" rx="0.95" fill-opacity="0.45" />
    </svg>
  )
}

/** The system menu's mark: a rounded diamond, nobody's logo. */
export function LogoGlyph({ class: className }: GlyphProps) {
  return (
    <svg
      class={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="3"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path d="M12 3.5 20.5 12 12 20.5 3.5 12Z" />
    </svg>
  )
}
